interface TimelineItem {
  title: string;
  description?: string;
  date?: string;
  icon?: string;
}

interface TimelineProps {
  title?: string;
  items?: TimelineItem[];
  orientation?: 'vertical' | 'horizontal';
}

export function TimelineBlock({ props }: { props: TimelineProps }) {
  const items = props.items ?? [];
  if (items.length === 0) return null;

  return (
    <section className="py-12 px-4">
      {props.title && <h2 className="text-2xl font-bold text-center mb-10">{props.title}</h2>}
      <div className="max-w-2xl mx-auto relative">
        <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-zinc-200" />
        <div className="space-y-8">
          {items.map((item, i) => (
            <div key={i} className="relative pl-12">
              <div className="absolute left-2.5 top-1 w-3 h-3 rounded-full bg-indigo-500 border-2 border-white" />
              {item.date && <span className="text-xs text-zinc-400 font-mono">{item.date}</span>}
              <h3 className="font-semibold text-zinc-900">{item.title}</h3>
              {item.description && <p className="text-sm text-zinc-500 mt-1">{item.description}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
